import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./list_map_toggle.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
